var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 4.40078V2.60078H1.8V4.40078H16.2ZM16.2 8.00078H1.8V13.4008H16.2V8.00078ZM0 2.60078C0 1.61078 0.81 0.800781 1.8 0.800781H16.2C16.6774 0.800781 17.1352 0.990423 17.4728 1.32799C17.8104 1.66555 18 2.12339 18 2.60078V13.4008C18 13.8782 17.8104 14.336 17.4728 14.6736C17.1352 15.0111 16.6774 15.2008 16.2 15.2008H1.8C1.32261 15.2008 0.864773 15.0111 0.527208 14.6736C0.189642 14.336 0 13.8782 0 13.4008V2.60078ZM3.6 9.80078H7.2V11.6008H3.6V9.80078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon);
export default __webpack_public_path__ + "static/media/invoicesIcon.fdda7147e88b58a7826484044bdf2683.svg";
export { ForwardRef as ReactComponent };